
import { Calendar as CalendarIcon, Users, Home, FileText, Landmark, BookOpen } from 'lucide-react';
import { ElectoralResource } from './types';

export const MUNICIPALITIES = [
  'Ahumada', 'Aldama', 'Allende', 'Aquiles Serdán', 'Ascensión',
  'Bachíniva', 'Balleza', 'Batopilas de Manuel Gómez Morín', 'Bocoyna', 'Buenaventura',
  'Camargo', 'Carichí', 'Casas Grandes', 'Coronado', 'Coyame del Sotol',
  'La Cruz', 'Cuauhtémoc', 'Chínipas', 'Chihuahua', 'Matachí',
  'Morelos', 'Nonoava', 'Ojinaga', 'Cusihuiriachi', 'Delicias',
  'Dr. Belisario Domínguez', 'El Tule', 'Galeana', 'Gómez Farías', 'Gran Morelos',
  'Guachochi', 'Guadalupe', 'Guadalupe y Calvo', 'Guazapares', 'Guerrero',
  'Hidalgo del Parral', 'Huejotitán', 'Ignacio Zaragoza', 'Janos', 'Jiménez',
  'Juárez', 'Manuel Benavides', 'Matamoros', 'Moris', 'Nuevo Casas Grandes',
  'Praxedis G. Guerrero', 'Riva Palacio', 'Rosales', 'Rosario', 'San Francisco de Borja',
  'San Francisco de Conchos', 'San Francisco del Oro', 'Santa Bárbara', 'Satevó', 'Saucillo',
  'Temósachic', 'Urique', 'Uruachi', 'Valle de Zaragoza', 'Ocampo',
  'Julimes', 'López', 'Madera', 'Maguarichi', 'Manuel Doblado',
  'Meoqui', 'Namiquipa'
];

export const MENU_ITEMS = [
  { id: 'agenda' as const, label: 'Agenda', icon: CalendarIcon },
  { id: 'bitacora' as const, label: 'Bitácora', icon: BookOpen },
  { id: 'reuniones' as const, label: 'Reuniones', icon: Users },
  { id: 'propuestas' as const, label: 'Propuestas', icon: Home },
  { id: 'gestiones' as const, label: 'Gestiones', icon: FileText },
  { id: 'electoral' as const, label: 'Electoral', icon: Landmark },
];

// Generate Mock Electoral Data
const generateElectoralData = (): ElectoralResource[] => {
  const data: ElectoralResource[] = [];
  let idCounter = 1;

  MUNICIPALITIES.forEach(m => {
    // 2018: Presidencia & Alcaldía
    data.push({
      id: `ELE-${idCounter++}`,
      municipality: m,
      year: '2018',
      position: 'Presidencia',
      title: `Resultados Presidenciales 2018 - ${m}`,
      url: '#'
    });
    data.push({
      id: `ELE-${idCounter++}`,
      municipality: m,
      year: '2018',
      position: 'Alcaldía',
      title: `Resultados Alcaldía 2018 - ${m}`,
      url: '#'
    });

    // 2021: Gubernatura & Alcaldía (Chihuahua Governor election was 2021)
    data.push({
      id: `ELE-${idCounter++}`,
      municipality: m,
      year: '2021',
      position: 'Gubernatura',
      title: `Resultados Gubernatura 2021 - ${m}`,
      url: '#'
    });
    data.push({
      id: `ELE-${idCounter++}`,
      municipality: m,
      year: '2021',
      position: 'Alcaldía',
      title: `Resultados Alcaldía 2021 - ${m}`,
      url: '#'
    });

    // 2024: Presidencia & Alcaldía
    data.push({
      id: `ELE-${idCounter++}`,
      municipality: m,
      year: '2024',
      position: 'Presidencia',
      title: `Resultados Presidenciales 2024 - ${m}`,
      url: '#'
    });
    data.push({
      id: `ELE-${idCounter++}`,
      municipality: m,
      year: '2024',
      position: 'Alcaldía',
      title: `Resultados Alcaldía 2024 - ${m}`,
      url: '#'
    });
  });

  return data;
};

export const MOCK_ELECTORAL_RESOURCES = generateElectoralData();